












import { Component, Mixins, Prop } from "vue-property-decorator";
import { IReplaceParameters } from "../../../../../../domain/document";
import { InjectedObjectEvidencePresentableMixin } from "./mixins";
import { default as InjectedObjectEvidenceTextContentDrawer } from "./InjectedObjectEvidenceTextContentDrawer.vue";
import { default as InjectedObjectEvidenceHtmlContentDrawer } from "./InjectedObjectEvidenceHtmlContentDrawer.vue"; 
import { default as InjectedObjectEvidenceUrlContentDrawer } from "./InjectedObjectEvidenceUrlContentDrawer.vue";
  
@Component({
  components: {
    InjectedObjectEvidenceTextContentDrawer,
    InjectedObjectEvidenceHtmlContentDrawer,
    InjectedObjectEvidenceUrlContentDrawer,
  }
})
export default class InjectedObjectEvidenceDrawer extends Mixins(InjectedObjectEvidencePresentableMixin) {
  @Prop()
  replaceParameters: IReplaceParameters;

  get contentComponentName(): string | undefined {
    return ["text", "html", "url"].includes(this.type)
      ? "injected-object-evidence-" + this.type + "-content-drawer"
      : undefined;
  }
}
